<template>
  <div class="add-box">
    <el-form ref="userform" :model="userform" label-width="120px" class="user-form">
      <el-form-item label="用户名:">
        <el-input v-model="userform.username" placeholder="登录账号" class="user-input" />
      </el-form-item>

      <el-form-item label="所属部门:">
        <el-cascader
          ref="lastdept"
          v-model="currentDeptId"
          :show-all-levels="false"
          :options="lastdeptList"
          :props="optionProps"
          class="user-input"
          placeholder="所属部门"
          @change="lastdeptChange"
        />
      </el-form-item>

      <el-form-item label="密码:">
        <el-input v-model="userform.password" placeholder="******" class="user-input" />
      </el-form-item>
      <el-form-item label="邮箱:">
        <el-input v-model="userform.email" placeholder="邮箱" class="user-input" />
      </el-form-item>
      <el-form-item label="手机号:">
        <el-input
          v-model="userform.mobile"
          placeholder="手机号"
          class="user-input"
          maxlength="11"
        />
      </el-form-item>

      <el-form-item label="角色:">
        <el-checkbox-group v-model="userform.roleIdList">
          <el-checkbox
            v-for="(current, index) in roleList"
            :key="index"
            :label="current.roleId"
          >
            {{ current.roleName }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="状态:">
        <el-radio v-model="userform.status" label="0">禁用</el-radio>
        <el-radio v-model="userform.status" label="1">正常</el-radio>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.stop="update">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { Checkout } from '@/utils/checkout' // 校验数据
const _checkout = new Checkout()

export default {
  data() {
    return {
      lastdeptList: [],
      deptList: [],
      allDeptList: [],
      roleList: [],
      deptInfo: [],
      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'deptId',
        label: 'name',
        children: 'children'
      },

      userform: {
        userId: '',
        createTime: '',
        username: '',
        deptId: '',
        deptName: '',
        password: '',
        email: '',
        mobile: '',
        roleIdList: [],
        status: '1'
      },
      currentDeptId: []
    }
  },

  created() {
    const vm = this
    vm.$emit('setCurrentMenu', '管理员管理')
    vm.getdeptList()
    vm.getroleList()
  },

  methods: {
    /**
     * 获取部门信息
     */
    getdeptList() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/sys/dept/list')
        .then((res) => {
          const data = res && res.data
          vm.allDeptList = data
          vm.lastdeptList = vm.filterNull(
            vm.toTreeData(JSON.parse(JSON.stringify(data)), 'parentId', 'deptId')
          )
          vm.deptList = vm.lastdeptList

          vm.getUserInfo()
        })
        .catch((error) => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    },

    /**
     * 获取角色列表数据
     */
    getroleList() {
      const vm = this

      vm.axios
        .get(vm.homePath() + '/sys/role/select')
        .then((response) => {
          if (response && response.data && response.data.status === '000000') {
            const data = response.data.list
            vm.roleList = data
          } else {
            console.log(response.data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    /**
     * 获取管理员信息
     */
    getUserInfo() {
      const vm = this
      const { allDeptList } = vm
      const userId = vm.$route.params.id

      vm.axios
        .get(vm.homePath() + '/sys/user/info/' + userId)
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.userform = data.user
            vm.userform.status = data.user.status.toString()
            vm.currentDeptId = data.user.deptId

            // 遍历部门信息，获取到对应的部门名称
            allDeptList &&
              allDeptList.forEach((items) => {
                if (items.deptId == data.user.deptId) {
                  vm.userform.deptName = items.name
                }
              })
          }
        })
        .catch((error) => console.log(error))
    },

    lastdeptChange(val) {
      this.userform.deptId = val
      this.userform.deptName = this.$refs['lastdept'].getCheckedNodes()[0].label
    },

    update() {
      let past = true
      if (!this.userform.username) {
        this.$alert('用户名不能为空', '提示')
        past = false
      } else if (!this.userform.deptName) {
        this.$alert('请选择所属部门', '提示')
        past = false
      } else if (!this.userform.email) {
        this.$alert('邮箱不能空', '提示')
        past = false
      } else if (_checkout.checkEmail(this.userform.email)) {
        this.$alert('邮箱地址不正确', '提示')
        past = false
      } else if (!this.userform.mobile) {
        this.$alert('手机号不能空', '提示')
        past = false
      } else if (_checkout.checkMobile(this.userform.mobile)) {
        this.$alert('手机号码不正确', '提示')
        past = false
      } else if (this.userform.roleIdList.length === 0) {
        this.$alert('请至少选择一个角色', '提示')
        past = false
      } else if (!this.userform.username) {
        this.$alert('登录账户不能为空', '提示')
        past = false
      }

      if (past) {
        this.axios
          .post(this.homePath() + '/sys/user/update', this.userform)
          .then((response) => {
            if (response && response.data && response.data.status === '000000') {
              this.$alert('修改成功', '提示', {
                callback: () => {
                  this.$router.push('/index/user')
                }
              })
            } else {
              console.log(response && response.data && response.data.message)
            }
          })
          .catch((error) => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/user')
    }
  }
}
</script>

<style>
.el-radio-button__inner,
.el-radio-group {
  vertical-align: baseline;
}
</style>
